// Проверка надобности визы (.visa-check).
//
// Отправляем форму на сервер (mod_visa, action=checkVisa), получаем ГОТОВЫЙ HTML
// результата и целиком кладём его в .visa-check-answer, затем показываем (.active).
// Вся логика проверки — на сервере (XSLT), фронт только отправляет и вставляет ответ.
// Перед отправкой — клиентская валидация (все поля обязательны + даты не в прошлом,
// отбытие не раньше прибытия); ошибки показываем кастомным попапом (не alert).

import { showAlert } from "../Popup/Popup-alert.js";

const VISA_CHECK_MID = 1; // mod_visa в таблице modules

// Поля формы и как их называть в сообщении об ошибке (порядок = порядок проверки).
const REQUIRED_FIELDS = [
	["passport_country", "страну паспорта"],
	["arrival_from_country", "страну вылета"],
	["arrival_transport", "транспорт прибытия"],
	["arrival_date", "дату прибытия"],
	["arrival_time", "время прибытия"],
	["departure_to_country", "страну после Сингапура"],
	["departure_transport", "транспорт отбытия"],
	["departure_date", "дату отбытия"],
	["departure_time", "время отбытия"],
];

document.querySelectorAll('.visa-check__form').forEach(initVisaCheck);
document.querySelectorAll('.form-custom-select--time').forEach(initTimeSelect);

// Кастомный селект времени: при открытии прокручиваем список к выбранному пункту,
// иначе к 12:00 (центрируем в видимой области дропдауна). Открытие/выбор — initCustomSelect.
function initTimeSelect(root) {
	const input = root.querySelector('.form-custom-select__field-input');
	const choice = root.querySelector('.form-custom-select__choice');
	if (!input || !choice) return;

	const scrollToTarget = () => requestAnimationFrame(() => {
		const checked = root.querySelector('.form-custom-select__choice-input:checked');
		let item = checked && checked.closest('.form-custom-select__choice-item');
		if (!item) {
			const noon = root.querySelector('.form-custom-select__choice-input[value="12:00"]');
			item = noon && noon.closest('.form-custom-select__choice-item');
		}
		if (item) choice.scrollTop = item.offsetTop - choice.clientHeight / 2 + item.offsetHeight / 2;
	});

	input.addEventListener('focus', scrollToTarget);
	input.addEventListener('click', scrollToTarget);
}

function initVisaCheck(form) {
	const root = form.closest('.visa-check') || document;
	const answer = root.querySelector('.visa-check-answer');
	if (!answer) return;

	form.addEventListener('submit', async (event) => {
		event.preventDefault();

		const data = new FormData(form);
		data.set('action', 'checkVisa');

		const error = validateCheckForm(data);
		if (error) {
			showAlert(error);
			return;
		}

		const submitBtn = form.querySelector('[type="submit"]');
		if (submitBtn) submitBtn.disabled = true;

		try {
			const response = await fetch(`/ajax.php?mid=${VISA_CHECK_MID}`, {
				method: 'POST',
				body: data,
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			});
			answer.innerHTML = await response.text();
			answer.classList.add('active');
			answer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		} catch (error) {
			console.error('[visa-check]', error);
			showAlert('Ошибка проверки. Попробуйте ещё раз.');
		} finally {
			if (submitBtn) submitBtn.disabled = false;
		}
	});

	// «Скопировать ответ» (кнопка приходит в HTML результата).
	answer.addEventListener('click', (event) => {
		const btn = event.target.closest('[data-copy-answer]');
		if (!btn || !navigator.clipboard) return;

		// Копируем только результат (вердикт + причины + данные), без кнопок навигации.
		const source = answer.querySelector('.visa-check-answer__result-container') || answer;
		navigator.clipboard.writeText(source.innerText.trim()).then(() => {
			btn.classList.add('is-copied');
			clearTimeout(btn._copiedTimer);
			btn._copiedTimer = setTimeout(() => btn.classList.remove('is-copied'), 1500);
		});
	});
}

// Проверка формы перед отправкой. Возвращает текст ошибки или null (всё ок).
function validateCheckForm(data) {
	for (const [key, label] of REQUIRED_FIELDS) {
		if (!String(data.get(key) || "").trim()) return `Укажите ${label}.`;
	}

	const arrival = parseDateTime(data.get("arrival_date"), data.get("arrival_time"));
	const departure = parseDateTime(data.get("departure_date"), data.get("departure_time"));
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	if (arrival && arrival < today) return "Дата прибытия не может быть в прошлом.";
	if (departure && departure < today) return "Дата отбытия не может быть в прошлом.";
	if (arrival && departure && departure < arrival) return "Отбытие не может быть раньше прибытия.";

	return null;
}

// дд.мм.гггг + ЧЧ:ММ → Date (null, если дата не распознана).
function parseDateTime(date, time) {
	const d = String(date || "").match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
	if (!d) return null;
	const t = String(time || "").match(/^(\d{1,2}):(\d{2})$/);
	const hh = t ? +t[1] : 0;
	const mm = t ? +t[2] : 0;
	return new Date(+d[3], +d[2] - 1, +d[1], hh, mm, 0, 0);
}
